const StringUtil = {
  /**
   * Interpolate a string.
   * @param {string} template - The template string to interpolate, with keys in the format %{key}.
   * @param {object} data - An object containing the keys and values to replace in the template.
   * @returns {string} - The interpolated string.
   */
  interpolateString(template, data) {
    return template.replace(/%{(\w+)}/g, (match, key) => {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        return data[key];
      }

      // %{key} not found, show a warning in the console and return an empty string
      // eslint-disable-next-line no-console
      console.warn(`Template error, %{${key}} not found:`, template);
      return '';
    });
  }
};

export default StringUtil;
